// extracted by mini-css-extract-plugin
export default {"prBreadcrumbArea":"Breadcrumb_prBreadcrumbArea__KmiWq","breadcrumbTitle":"Breadcrumb_breadcrumbTitle__bN+v3","breadcrumb--2":"Breadcrumb_breadcrumb--2__KP62I"};